module.exports = __webpack_public_path__ + "img/logo_list2.f73d38e9.png";